(() => {
    window.Dashboard = window.Dashboard || {}

    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Lookups = window.Dashboard.Models.Lookups || {};

    window.Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes = {
        sms: 1,
        push: 2,
        inbox: 6
    };
})();
